import { createMiddleware, createStart } from '@tanstack/react-start'
import { paraglideMiddleware } from '#/paraglide/server'

// Runs every request inside Paraglide's AsyncLocalStorage so getLocale()/m.*()
// resolve the visitor's locale (cookie → Accept-Language → en) during SSR.
const localeMiddleware = createMiddleware({ type: 'request' }).server(
  async ({ next, request }) => {
    let result: Awaited<ReturnType<typeof next>> | undefined
    const response = await paraglideMiddleware(request, async () => {
      result = await next()
      return result.response
    })
    if (result) return result
    return response
  },
)

// Boot the long-lived workers once per process on the first request (production only, env-gated):
// the by-Host proxy for published apps must listen before any visitor hits <slug>.apps.bystep.dev,
// and the Runner queue must resume runs that were queued before a restart. Dynamic imports keep
// server-only modules out of the client bundle.
const g = globalThis as { __bystepBoot?: Promise<void> }
const bootMiddleware = createMiddleware({ type: 'request' }).server(async ({ next }) => {
  if (!g.__bystepBoot) {
    g.__bystepBoot = (async () => {
      try {
        if (process.env.APPS_DNS_READY === '1' || process.env.PREVIEW_DOMAIN) (await import('#/lib/publish.server')).ensurePublishWorker()
        if (process.env.RUNNER_ENABLED === '1') (await import('#/lib/runner/orchestrator.server')).ensureRunnerWorker()
      } catch (e) {
        console.warn('[boot] worker start failed', e instanceof Error ? e.message : e)
      }
    })()
  }
  return next()
})

export const startInstance = createStart(() => ({
  requestMiddleware: [localeMiddleware, bootMiddleware],
}))
